var _style, _g, _g2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "VkLogo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "800px",
    height: "800px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0VkLogo{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0VkLogo",
    d: "M733,220.8c4.9-16.2,0-28.1-23.1-28.1h-76.4c-19.4,0-28.3,10.3-33.2,21.6c0,0-38.8,94.7-93.9,156.1 c-17.8,17.9-25.9,23.5-35.6,23.5c-4.8,0-11.9-5.6-11.9-21.8V220.8c0-19.4-5.6-28.1-21.8-28.1h-120c-12.1,0-19.4,9-19.4,17.6 c0,18.4,27.5,22.6,30.3,74.5v112.4c0,24.6-4.4,29.1-14.2,29.1c-25.9,0-88.9-95.1-126.2-203.9c-7.3-21.1-14.6-29.7-34.1-29.7H77.2 C55.4,192.8,51,203,51,214.3c0,20.3,25.9,120.6,120.5,253.3c63.1,90.6,152,139.7,232.9,139.7c48.5,0,54.5-10.9,54.5-29.7v-68.5 c0-21.8,4.6-26.2,20-26.2c11.3,0,30.7,5.7,76,49.4c51.8,51.8,60.3,75,89.4,75h76.3c21.8,0,32.7-10.9,26.4-32.4 c-6.9-21.4-31.6-52.6-64.4-89.5c-17.8-21-44.5-43.7-52.6-55c-11.3-14.6-8-21,0-34C630.3,396.4,723.3,265.3,733,220.8L733,220.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.2f371bb56763c79f380b206b35798720.svg";
export { ForwardRef as ReactComponent };